import { Grid2 } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import {
	EndFilter,
	StartFilter,
} from "../../../shared/components/StartEndFilter";
import { LinesFilter } from "../../../shared/components/filters/LinesFilter";

type Props = {
	onFilterChange: (startDate: Moment, endDate: Moment) => void;
	initialStartDate: Moment;
	initialEndDate: Moment;
	filterLine: number | null;
	onFilterLineChange: (assetId: number | null) => void;
};

export const Filters: FC<Props> = ({
	onFilterChange,
	initialStartDate,
	initialEndDate,
	filterLine,
	onFilterLineChange,
}) => {
	const [startDate, setStartDate] = useState<Moment>(initialStartDate);
	const [endDate, setEndDate] = useState<Moment>(initialEndDate);

	useEffect(() => {
		setStartDate(initialStartDate);
		setEndDate(initialEndDate);
	}, [initialStartDate, initialEndDate]);

	const handleStartDateChange = (date: Moment | null) => {
		if (date) {
			setStartDate(date);
			onFilterChange(date, endDate);
		}
	};

	const handleEndDateChange = (date: Moment | null) => {
		if (date) {
			setEndDate(date);
			onFilterChange(startDate, date);
		}
	};

	return (
		<Grid2 container style={{ alignItems: "center" }} spacing={2}>
			<Grid2 size={{ xs: 12, md: 4 }}>
				<StartFilter value={startDate} onChange={handleStartDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: 4 }}>
				<EndFilter value={endDate} onChange={handleEndDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: 4 }}>
				<LinesFilter value={filterLine} onChange={onFilterLineChange} />
			</Grid2>
		</Grid2>
	);
};
